export default __webpack_public_path__ + "static/media/1x2.bb019fe8.png";